import { Location, SupportedServiceType, Table } from "../../../model/Location";
import { SignInProviders } from "../../authentications/models/BaseUser";
import { EnvNames } from "../../common/configs/EnvNames";
import { getTableServiceTypes } from "../../tables/services/TableService";

const LYF_IN_APP_PAYMENT_DEV = "https://sandbox-app.lyf.eu";
const LYF_IN_APP_PAYMENT_PROD = "https://app.lyf.eu";

export const LYF_SUBDOMAIN_MAP = {
    [EnvNames.LOCAL]: '',
    [EnvNames.DEV]: '',
    [EnvNames.PREPROD]: 'https://lyf-preprod.web.app',
    [EnvNames.PROD]: 'https://lyf.fyre.app'
}

export enum LyfInAppFeatures {
    PAY_AT_TABLE = "pay_at_table",
    ORDER_AT_TABLE = "order_at_table",
    CLICK_AND_COLLECT_FOOD = "click_and_collect_food"
}

export const getLyfInAppUrl = (shopUuid: string, tablelinkId: string, environment?: EnvNames, table?: Table, location?: Location, forServiceType?: SupportedServiceType) => {
    let baseUrl = LYF_IN_APP_PAYMENT_PROD;
    if (environment === EnvNames.DEV) {
        baseUrl = LYF_IN_APP_PAYMENT_DEV;
    }
    let lyfFeature: LyfInAppFeatures = LyfInAppFeatures.PAY_AT_TABLE;

    if (!forServiceType && table) {
        const tableServiceTypes = getTableServiceTypes(table, false, location);
        if (tableServiceTypes && tableServiceTypes.length) {
            forServiceType = tableServiceTypes[0];
        }
    }

    if (forServiceType) {

        if (forServiceType === SupportedServiceType.CHECKOUT) {
            lyfFeature = LyfInAppFeatures.PAY_AT_TABLE;
        } else if (forServiceType === SupportedServiceType.EAT_IN ||
            forServiceType === SupportedServiceType.VIEW) {
            lyfFeature = LyfInAppFeatures.ORDER_AT_TABLE;
        } else if (forServiceType === SupportedServiceType.COLLECTION ||
            forServiceType === SupportedServiceType.DELIVERY) {
            lyfFeature = LyfInAppFeatures.CLICK_AND_COLLECT_FOOD;
        }
    }

    return `${baseUrl}/shops/${shopUuid}/features/${lyfFeature}?tablelinkId=${tablelinkId}&from=${SignInProviders.LYF}`;
}